import { Navigate, useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext.jsx";
import StripeCheckout from "../stripe/StripeCheckout.jsx";

const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export default function PaymentPage() {
  const navigate = useNavigate();
  const { order } = useOrder();

  // Payment depends on the in-memory sign-up data. If someone lands here
  // directly or refreshes, there's nothing to pay for — send them back.
  if (!order) {
    return <Navigate to="/" replace />;
  }

  return (
    <section className="card">
      <h2 className="card__title">Payment</h2>
      <p className="card__subtitle">Review your details and complete payment.</p>

      <dl className="summary">
        <div className="summary__row">
          <dt className="summary__label">Name</dt>
          <dd className="summary__value">{order.name}</dd>
        </div>
        <div className="summary__row">
          <dt className="summary__label">Email</dt>
          <dd className="summary__value">{order.email}</dd>
        </div>
        <div className="summary__row">
          <dt className="summary__label">Amount</dt>
          <dd className="summary__value">{usd.format(order.amount)}</dd>
        </div>
      </dl>

      <StripeCheckout order={order} />

      <button
        className="btn btn--ghost"
        type="button"
        onClick={() => navigate("/")}
      >
        ← Back to sign up
      </button>
    </section>
  );
}
